import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const winLossSchema = z.object({ won: z.number(), lost: z.number() });

const bucketSchema = z.object({
  all: winLossSchema,
  excludingProtected: winLossSchema,
});

export const getReclaimWinRate = unaryRpc({
  name: "getReclaimWinRate" as const,
  input: z.object({}),
  output: z.object({
    week: bucketSchema,
    twoWeeks: bucketSchema,
    month: bucketSchema,
    allTime: bucketSchema,
  }),
});
